import { CheckIcon } from '@heroicons/react/24/solid'
import { useTranslation } from 'react-i18next'

const BULLET_POINTS = [1, 2, 3, 4]

export default function WhatYouGet() {
  const { t } = useTranslation()

  return (
    <div className="space-y-4">
      <h2 className="hw-heading">{t('pages.checkout.v1.whatYouGet')}</h2>

      <ul className="hw-card space-y-5 p-5">
        {BULLET_POINTS.map((bulletPoint) => (
          <li className="flex items-start gap-3" key={bulletPoint}>
            <span className="bg-hw-primary-soft mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full">
              <CheckIcon className="text-hw-primary h-4 w-4" />
            </span>

            <div className="space-y-1">
              <p className="text-hw-ink text-[15px] leading-snug font-semibold">
                {t(`pages.checkout.plans.bulletPoints.title${bulletPoint}`)}
              </p>

              <p className="text-hw-muted text-sm leading-relaxed">
                {t(`pages.checkout.plans.bulletPoints.text${bulletPoint}`)}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
